import { store } from "App/redux";
import React from "react";
import { Provider } from "react-redux";
import AppStyledTemplate from "../appStyledTemplate";
export default function AppTemplate({ children }) {
    return (React.createElement(Provider, { store: store },
        React.createElement(AppStyledTemplate, null, children)));
}
